import { render } from "./home-landing.vue?vue&type=template&id=2977cf84"
import script from "./home-landing.vue?vue&type=script&lang=js"
export * from "./home-landing.vue?vue&type=script&lang=js"

import "./home-landing.vue?vue&type=style&index=0&id=2977cf84&lang=scss"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__